import React, { useState } from 'react';
import ReusableModal from './ReusableModal';
import ImpressumContent from './legal/ImpressumContent';

const DATENSCHUTZ_URL = 'https://www.schickler.de/datenschutz/';

export default function LandingFooter() {
  const year = new Date().getFullYear();
  const [isImpressumOpen, setIsImpressumOpen] = useState(false);

  return (
    <footer className="footer-shell footer-shell--landing" role="contentinfo">
      <div className="footer-content footer-content--landing-bar footer-content--slim">
        <nav className="footer-landing-links" aria-label="Rechtliches">
          <button
            type="button"
            className="footer-meta footer-meta--link"
            onClick={() => setIsImpressumOpen(true)}
          >
            Impressum
          </button>
          <a
            href={DATENSCHUTZ_URL}
            className="footer-meta footer-meta--link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Datenschutz
          </a>
        </nav>
        <span className="footer-meta">{`Console ${year}`}</span>
      </div>

      <ReusableModal
        isOpen={isImpressumOpen}
        onClose={() => setIsImpressumOpen(false)}
        title="Impressum"
      >
        <ImpressumContent />
      </ReusableModal>
    </footer>
  );
}
